export const planTableConfig = {
  propList: [
    {prop: 'empName', label: '业务员', minWidth: '60', slotName: 'consumer'},
    {prop: 'statisticsCount', label: '总数', minWidth: '60', sortable: true},
    {prop: 'developCount', label: '开发数', minWidth: '60', sortable: true},
    {prop: 'dealCount', label: '已成交', minWidth: '60', sortable: true},
    {prop: 'noCommunicate', label: '未沟通', minWidth: '60', sortable: true}
  ]
}
